"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCurrencyFormatter = exports.createNumberFormatter = void 0;
const fallbackConfig = {
    countryCode: "DE",
    language: "de",
    currency: "code",
    currencyISOCode: "EUR",
    showDecimals: true,
};
const createLocale = ({ language, countryCode, }) => `${language}-${countryCode}`;
const createCurrencyFormatterOptions = ({ currencyISOCode, currency, showDecimals, }) => {
    return {
        style: "currency",
        currency: currencyISOCode,
        currencyDisplay: currency ?? fallbackConfig.currency,
        minimumFractionDigits: showDecimals ? 2 : 0,
    };
};
const createNumberFormatter = (config, logger) => {
    const locale = createLocale(config);
    try {
        return new Intl.NumberFormat(locale);
    }
    catch (err) {
        const fallbackLocale = createLocale(fallbackConfig);
        logger?.error(`Error creating number formatter with locale "${locale}". Falling back to a fallback locale "${fallbackLocale}": ${err}`);
    }
    return new Intl.NumberFormat(createLocale(fallbackConfig));
};
exports.createNumberFormatter = createNumberFormatter;
const createCurrencyFormatter = (config, logger) => {
    const locale = createLocale(config);
    try {
        return new Intl.NumberFormat(locale, createCurrencyFormatterOptions(config));
    }
    catch (err) {
        const fallbackLocale = createLocale(fallbackConfig);
        logger?.error(`Error creating currency formatter with locale "${locale}" and currency "${config.currencyISOCode}". Falling back to a fallback locale "${fallbackLocale} and fallback currency "${fallbackConfig.currencyISOCode}": ${err}`);
    }
    return new Intl.NumberFormat(createLocale(fallbackConfig), createCurrencyFormatterOptions(fallbackConfig));
};
exports.createCurrencyFormatter = createCurrencyFormatter;
//# sourceMappingURL=createIntlNumberFormat.js.map